
import { __ } from 'bits/intl'
import { Component, Prop, Vue } from 'bits/vue'
import OzIconButton, { OzIconButtonColorScheme } from 'library/v4/components/OzIconButton.vue'

@Component({ components: { OzIconButton } })
export default class OzBackButton extends Vue {
  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Automatically uses an `<a>` tag if href is present, `<button>` otherwise.
   */
  @Prop({ default: undefined }) href?: string

  /**
   * Button label.
   */
  @Prop({ default: __('Go back') }) label!: string

  /**
   * See `OzContainedButton`.
   */
  @Prop({ default: OzIconButtonColorScheme.Secondary }) colorScheme!: OzIconButtonColorScheme

  /**
   * Override the preset icon size.
   * See `OzIconButton`.
   */
  @Prop({ required: false }) iconSize?: number
}

export { OzIconButtonColorScheme as OzBackButtonColorScheme }
